import React, { ReactNode } from 'react'
import { useSubscriptionData, SubscriptionData } from 'hooks/subscriptions'
import { ItemRenderer } from 'scenes/Product/components/OptionsSection/components/Subscriptions/components/ItemRenderer'
import { MagentoMoney } from 'lib/types'

interface Props {
  frequencies: string[]
  productPrice: {
    maximum_price: {
      final_price: MagentoMoney
    }
  }
  shipmentFrequency: number
  productId: number
  setShipmentFrequency: (frequency: number) => void
  packageQty: string
  setPacksToAdd: (packs: any) => void
  quantityPerDay: number
  subtitle?: ReactNode
  title?: string
}

export const SubscriptionOptions: React.FC<Props> = ({
  frequencies,
  productPrice,
  shipmentFrequency,
  productId,
  setShipmentFrequency,
  packageQty,
  setPacksToAdd,
  quantityPerDay,
  subtitle,
  title
}) => {
  const { subscriptionsData } = useSubscriptionData(frequencies, productPrice)
  const selectedShipment = subscriptionsData?.find(subscription => subscription.itemFrequency === shipmentFrequency)

  return (
    <>
      <h5>{title}</h5>
      {subtitle && subtitle}
      <div>
        {subscriptionsData?.map((item: SubscriptionData, i) => {
          return (
            <ItemRenderer
              key={i}
              productId={productId}
              price={item.price}
              frequency={item.itemFrequency}
              packageQty={packageQty}
              setFrequency={setShipmentFrequency}
              setPacksToAdd={setPacksToAdd}
              qtyPerDay={quantityPerDay}
              classNameSelected={selectedShipment?.itemFrequency === item.itemFrequency ? 'selected' : 'not-selected'}
            />
          )
        })}
      </div>
    </>
  )
}
